import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../data/store'

const getCalendarState = (state: RootState) => state?.calendar

export const getCalendarShowCalendarLiveModal = createSelector(
  getCalendarState,
  (calendarState) => calendarState?.showCalendarLiveModal,
)

export const getShowCalendarTransitionModal = createSelector(
  getCalendarState,
  (calendarState) => calendarState?.showCalendarTransitionModal,
)
